export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.mobile-nav-trigger').bind('click touchstart', function(event) {
      event.preventDefault();
      $('body').toggleClass('nav-popup-visible');
      $(this).toggleClass('active');

      if($('.nav-primary-mobile .mobile-parent').hasClass('active')) {
        $('.nav-primary-mobile .mobile-parent').removeClass('active');
        $('.nav-primary-mobile .mobile-parent').find('.sub-menu').removeClass('active').slideUp();
      }

      //$('.mobile-nav-wrapper').toggleClass('active');
    });

    function closeMobileNav() {
      $('body').removeClass('nav-popup-visible');
      $('.mobile-nav-trigger').removeClass('active');
    }

    if(window.innerWidth > 1024) {
      closeMobileNav();
    }

    $(window).resize(function(){
      if(window.innerWidth > 1024) {
        setTimeout(function() {
          closeMobileNav();
        }, 100);
      }
    });

    $('.quote-carousel').slick({
      dots: false,
      infinite: true,
      speed: 1000,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      autoplay: true,
      draggable: false,
      arrows: false,
      swipe: false,
      controls: false,
      slidesToScroll: 1,
      fade: true,
      cssEase: 'linear',
    });

    // When the user scrolls the page, execute myFunction
    window.onscroll = function(){
      headerShadow()
    };

    // Get the header
    var header = $('.banner');

    function headerShadow() {
      if (window.pageYOffset > 2) {
        header.addClass('shadow');
      } else {
        header.removeClass('shadow');
      }
    }

    // accordions

    var canclickquestion = true;
    $('.accordion-trigger').on('click', function() {
      if (canclickquestion) {
        canclickquestion = false;
        if($(this).hasClass('accordion-trigger')) {
          $(this).parent().toggleClass('active');
        }
        $(this).toggleClass('active').next('.accordion-content').slideToggle(300, function() {
          // Animation complete.
          canclickquestion = true;
        });
      }
    });

    // modal

    var modal = $('.modal');
    var trigger = $('.modal-trigger');
    var closeButton = $('.close-button');

    function toggleModal() {
      modal.toggleClass('show-modal');
      $('body').toggleClass('modal-visible');
    }

    function windowOnClick(event) {
      var target = $(event.target);
      if (target.is(modal)) {
        toggleModal();
      }
    }

    trigger.on('click', toggleModal);
    closeButton.on('click', toggleModal);
    $(window).on('click', windowOnClick);

    $('.down-arrow').on('click', function() {
      $('html, body').animate({
        scrollTop: $('.page-banner').next('.page-section').offset().top,
      }, 800, function() {
        // Animation complete.
      });
    })

    var $pagebannercarousel = $('.page-banner-carousel');

    $pagebannercarousel.slick({
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 800,
      pauseOnHover: false,
      pauseOnFocus: false,
    });

    $pagebannercarousel.not('.home .page-banner-carousel').on('afterChange', function(e, slick) {
      if( slick.currentSlide == 0 ) {
        $pagebannercarousel.slick('setOption', 'autoplaySpeed', 2000);
      } else if( slick.currentSlide == 1 ) {
        $pagebannercarousel.slick('setOption', 'autoplaySpeed', 5000);
      }

      console.log('change');
    });


    // animation

    jQuery(document).ready(function($) {
      var revealClass = '.animated';
      var targetClass = '.has-scroll-reveal:not(' + revealClass + ')';
      var offset = 100; // Offset from bottom of viewport in pixels.

      var winHeight = $(window).height();

      // Recalc height of window in case of resize
      $(window).bind('resizeEnd', function() {
        winHeight = $(window).height();
      });

      // Fire when page loads
      triggerAnimation(revealClass, targetClass, offset, winHeight);

      // Also fire on scroll
      $(window).on('scroll', function() {
        triggerAnimation(revealClass, targetClass, offset, winHeight);
      }); // window.on('scroll')
    }); // document.ready

    function triggerAnimation(revealClass, targetClass, offset, winHeight) {
      // Get current scrollPos
      var trigger = $(window).scrollTop() + winHeight - offset;

      // Loop through elements we're affecting
      $(targetClass).each(function() {
        var elementOffset = $(this).offset().top;

        if (elementOffset < trigger) {
          $(this).addClass(revealClass.replace('.',''));
        }
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js